import React, { useEffect, useRef, useState } from 'react';
import { NavLink, useLocation, Link, Routes, Route } from "react-router-dom";
import classes from './Landingpage.module.css';
import Navigation from '../../Components/Navigation/Navigation'
import Footer from '../../Components/Footer/Footer'
import lilstar from '../../Assets/lilstar.png';
import Getstarted from '../../Components/Get started/Getstarted'
import smllimg from '../../Assets/imageofhero.png';
import theimage from '../../Assets/the-image.png';
import theimagee from '../../Assets/digimart.png';
import theimageee from '../../Assets/bussupport.png';
import cloud from '../../Assets/cloudsoftware.png';
import process from '../../Assets/processauto.png';
import consult from '../../Assets/consult.png';
import prjctone from '../../Assets/kinra.png';
import prjcttu from '../../Assets/kinra2.png';
import prjcttr from '../../Assets/kinra3.png';
import imgcont from '../../Assets/imgcont.png';
import leftarrow from '../../Assets/leftarrow.png';
import rightarrow from '../../Assets/rightarrow.png';
import beamingsmile from '../../Assets/beaming-face-with-smiling-eyes.png';
import Contactus from '../../Components/Contactus Form/Contactus';
import testimonialImg1 from '../../Assets/imgone.png';
import testimonialImg2 from '../../Assets/imgtu.png';
import testimonialImg3 from '../../Assets/imgtri.png';
import testimonialImg4 from '../../Assets/imgfur.png';
import testimonialImg5 from '../../Assets/imgfive.png';





const testimonials = [

  {
    text: "Scaleworkflow has been a game-changer for our business. By handling our non-core functions, we've been able to focus on what matters most - delivering exceptional service to our customers",
    name: "Emily",
    position: "CEO of TechFlow Solutions",
    image: testimonialImg1,
  },
  {
    text: "The team at Scaleworkflow is incredibly professional and efficient. Their custom software development services have streamlined our operations and saved us time and resources.",
    name: "David",
    position: "Founder of Lee's Enterprises",
    image: testimonialImg2,
  },
  {
    text: "We've seen a significant increase in brand awareness and customer engagement since partnering with Scaleworkflow for our marketing needs. Their expertise has been invaluable.",
    name: "Rachel",
    position: "Marketing Director at Patel's Innovationse",
     image: testimonialImg3,
  },
  {
    text: "Scaleworkflow's business support services have allowed us to scale our business without sacrificing quality. Their team is responsive, reliable, and truly cares about our success.",
    name: "Michael",
    position: "Owner of Kim's Ventures",
    image: testimonialImg4,
  },
  {
    text: "Scaleworkflow's branding services helped us establish a strong identity for our company. Their creative team is talented and understands what it takes to make a brand stand out",
    name: "Sarah",
    position: "CEO of Taylor's Designs",
    image: testimonialImg5,
  },
];



const Landingpage = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [activeIndex, setActiveIndex] = useState(1); // Start with the middle card active
  const carouselRef = useRef(null);
  const [showContact, setShowContact] = useState(false);
  const [fullscreen, setFullscreen] = useState(true);
  // Autoplay effect
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) =>
        prev === testimonials.length - 1 ? 0 : prev + 1
      );
    }, 4000); // 4 seconds per slide
    return () => clearInterval(interval);
  }, [testimonials.length]);

  // Scroll to active card
  useEffect(() => {
    if (carouselRef.current) {
      const activeCard = carouselRef.current.children[activeIndex];
      if (activeCard) {
        activeCard.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
      }
    }
  }, [activeIndex]);



  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  // Handle previous and next button clicks


  const handlePrev = () => {
    setActiveIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setActiveIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };


  // carousel hero

  const kads = [
    (
      <div className={classes.landingPage__hero__cntnr}>
        <p className={classes.servicp}>Services</p>
        <div>
          <div className={classes.lilstar__cntnr}>
            <img src={lilstar} className={classes.lilstar} />
            <button className={classes.mbleapp}>Mobile App Design</button>
          </div>
          <div className={classes.lilstar__cntnr}>
            <button className={classes.mbleappconsult}>Consultation</button>
            <button className={classes.mbleapp}>Web Design</button>
          </div>
          <div className={classes.lilstar__cntnr}>
            <button className={classes.mbleapp}>Product Design</button>
            <button className={classes.mbleappconsult}>Brand Design</button>
          </div>
        </div>
      </div>
    ),
    (
      <div className={classes.landingPage__hero__shhii}>
        <img src={smllimg} className={classes.smllimg} />
        <p className={classes.allwhise}>"</p>
        <p className={classes.typingshi}>I absolutely loved the service working with this team made building my website smooth, fast, and stress-free!</p>
      </div>
    ),
    (
      <div className={classes.landingPage__hero__shhiiiii}>
        <img src={beamingsmile} className={classes.beamingsmile} />
        <p className={classes.bigtxt}>50+</p>
        <p className={classes.hppytxt}>Happy and satisfied customers served over the years.</p>
      </div>
    ),
  ];



  // Add this state and effect at the top of your component
  const [activeKad, setActiveKad] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveKad((prev) => (prev === kads.length - 1 ? 0 : prev + 1));
    }, 4000); // 4 seconds per kad
    return () => clearInterval(interval);
  }, []);

  // ...existing code...

  // function handleShow(breakpoint) {
  //     setFullscreen(breakpoint);
  //     setShow(true);
  //   }




  return (
    <>
      <Navigation />
      <div div className={classes.landingPage}>

        <section className={classes.landingPage__hero}>
          <div className={classes.containerherotxt}>
            <p className={classes.herotxt}>Your Business Partner for Excellence </p>
            <p className={classes.smalltxt}>We handle your non-core functions so you can focus on what matters most. From custom software development to branding, marketing, and business support. </p>
            <div className={classes.btns}>
              <button onClick={() => setShowContact(true)} className={classes.xplorebtn}>Get Started Now</button>
              <button onClick={() => setShowContact(true)} className={classes.consltbtn}>Get a Free Consultation</button>
            </div>
            <Contactus show={showContact} setShow={setShowContact} fullscreen={fullscreen} />
          </div>
          <div className={classes.allkads}>
            {/* <div className={classes.landingPage__hero__cntnr}>
            <p className={classes.servicp}>Services</p>
            <div>
              <div className={classes.lilstar__cntnr}>
                <img src={lilstar} className={classes.lilstar} />
                <button className={classes.mbleapp}>Mobile App Design</button>
              </div>
              <div className={classes.lilstar__cntnr}>
                <button className={classes.mbleappconsult}>Consultation</button>
                <button className={classes.mbleapp}>Web Design</button>
              </div>
              <div className={classes.lilstar__cntnr}>
                <button className={classes.mbleapp}>Product Design</button>
                <button className={classes.mbleappconsult}>Brand Design</button>
              </div>
            </div>
          </div>
          <div className={classes.landingPage__hero__shhii}>
            <img src={smllimg} className={classes.smllimg} />
            <p className={classes.allwhise}>"</p>
            <p className={classes.typingshi}>I absolutely loved the service working with this team made building my website smooth, fast, and stress-free!</p>
          </div>
          <div className={classes.landingPage__hero__shhiiiii}>
            <img src={beamingsmile} className={classes.beamingsmile} />
            <p className={classes.bigtxt}>50+</p>
            <p className={classes.hppytxt}>Happy and satisfied customers served over the years.</p>
          </div> */}

            <div
              className={classes.kadsSlider}
              style={{
                transform: `translateX(-${activeKad * 100}%)`,
                // transition: 'transform 0.7s cubic-bezier(0.77,0,0.18,1)'
              }}
            >
              {kads.map((kad, idx) => (
                <div className={classes.kadSlide} key={idx}>
                  {kad}
                </div>
              ))}
            </div>
          </div>
        </section>

        <section>
          <div className={classes.ontainerhcdjssp}>
            <p className={classes.exceptionp}>Exceptional Services we have for you</p>
          </div>

          <div className={classes.containerhdjss}>
            <div className={classes.containerhdjs}>
              <img src={theimage} className={classes.theimage} />
              <p className={classes.customp}>Custom Software Development</p>
              <p className={classes.lilp}>We build tailored digital solutions to meet your unique business requirements.</p>
            </div>
            <div className={classes.containerhdjs2}>
              <img src={theimagee} className={classes.theimagee} />
              <p className={classes.customp}>Digital Marketing & Branding </p>
              <p className={classes.lilp}>We help you establish a strong online presence and build a recognizable brand.</p>
            </div>
            <div className={classes.containerhdjs}>
              <img src={theimageee} className={classes.theimage} />
              <p className={classes.customp}>Business Support </p>
              <p className={classes.lilp}>We provide essential services to optimize your daily operations and tasks.</p>
            </div>
          </div>
          <div className={classes.containerhdjss2}>
            <div className={classes.containerhdjs2}>
              <img src={cloud} className={classes.theimagee} />
              <p className={classes.customp}>Cloud Solutions </p>
              <p className={classes.lilp}>We offer expertise in leveraging cloud technologies for scalability and efficiency.</p>
            </div>

            <div className={classes.containerhdjs}>
              <img src={process} className={classes.theimage} />
              <p className={classes.customp}>Process Automation</p>
              <p className={classes.lilp}>EWe streamline your workflows using automation tools to enhance productivity.</p>
            </div>

            <div className={classes.containerhdjs}>
              <img src={consult} className={classes.theimage} />
              <p className={classes.customp}>Consulting </p>
              <p className={classes.lilp}>Our expert consultants provide strategic guidance to improve your business. </p>
            </div>
          </div>
        </section>

        <section className={classes.howitworkscntr}>
          <p className={classes.howitworks} >How it works</p>
          <div className={classes.howitworks__cntnrmjr}>
            <div className={classes.howitworks__cntnr}>
              <div className={classes.howitworks__cntnr__div}>
                <p className={classes.howitworksnum}>1</p>
                <p className={classes.howitworks3}>Discovery</p>
                <p className={classes.howitworks2}>We start by understanding your needs and goals through workshops and interviews.</p>
              </div>
              <div className={classes.howitworks__cntnr__div}>
                <p className={classes.howitworksnum}>2</p>
                <p className={classes.howitworks3}>Proposal</p>
                <p className={classes.howitworks2}>We present tailored solutions, pricing, and timelines for your approval.
                </p>
              </div>
              <div className={classes.howitworks__cntnr__div}>
                <p className={classes.howitworksnum}>3</p>
                <p className={classes.howitworks3}>Execution</p>
                <p className={classes.howitworks2}>Our team gets to work, keeping you updated every step of the way.
                </p>
              </div>
            </div>
            <div className={classes.howitworks__cntnr}>
              <div className={classes.howitworks__cntnr__divexc}>
                <p className={classes.howitworksnum}>4</p>
                <p className={classes.howitworks3}>Delivery</p>
                <p className={classes.howitworks2}>We deliver the final product and provide training and documentation.</p>
              </div>
              <div className={classes.howitworks__cntnr__divexc}>
                <p className={classes.howitworksnum}>5</p>
                <p className={classes.howitworks3}>Support</p>
                <p className={classes.howitworks2}>We offer ongoing maintenance and support to ensure your success.
                </p>
              </div>

            </div>
          </div>
        </section>

        {/* <section>
          <div className={classes.containerhdjss3}>
            <p className={classes.prjcts}>Explore a collection of projects that showcase our creativity, commitment to delivering real results.</p>
            <Link to={'#'} >  <button className={classes.prjctsbtn}>See more works</button></Link>
          </div>
          <div className={classes.containerhdjss4}>
            <div className={classes.imgprtfl}>
              <img src={prjctone} className={classes.theprjcthi} />
              <div className={classes.imgsjh}>
                <p className={classes.customp}>Kinra </p>
                <button className={classes.wrkbtn}>Mobile App</button>
              </div>
            </div>
            <div className={classes.imgprtfl}>
              <img src={prjcttu} className={classes.theprjcthi} />
              <div className={classes.imgsjh}>
                <p className={classes.customp}>Kinra </p>
                <button className={classes.wrkbtn}>Mobile App</button>
              </div>
            </div>
            <div className={classes.imgprtfl}>
              <img src={prjcttr} className={classes.theprjcthi} />
              <div className={classes.imgsjh}>
                <p className={classes.customp}>Kinra </p>
                <button className={classes.wrkbtn}>Mobile App</button>
              </div>
            </div>
          </div>
        </section> */}
        <section>
          <div className={classes.containwatscustomesays}>

            <div className={classes.containerpsays}>
              <p className={classes.customerssays}>What our customers are saying.</p>
            </div>

            {/* <div className={classes.wholekadtstmnial}>
            <div className={classes.imgcardtstmnial}>
              <p className={classes.ptextnm}>Transactions were quite fast, After I paid for the Crypto it didn’t take long to receive it</p>
              <div className={classes.imgcontover}>
                <img src={imgcont} className={classes.imgcont} />
                <p className={classes.jhndoetxt}>John Doe</p>
              </div>

            </div>
            <div className={classes.imgcardtstmniallrg}>
              <div>
                <p className={classes.ptextnm2}>Transactions were quite fast, After I paid for the Crypto it didn’t take long to receive it</p>
                <div className={classes.imgcontover}>
                  <img src={imgcont} className={classes.imgcont} />
                  <p className={classes.jhndoetxt2}>John Doe</p>
                </div>
              </div>
            </div>

            <div className={classes.imgcardtstmnial}>
              <p className={classes.ptextnm}>Transactions were quite fast, After I paid for the Crypto it didn’t take long to receive it</p>
              <div className={classes.imgcontover}>
                <img src={imgcont} className={classes.imgcont} />
                <p className={classes.jhndoetxt}>John Doe</p>
              </div>

            </div>

          </div> */}

            <div className={classes.wholekadtstmnial}>
              {testimonials.map((item, idx) => (
                <div
                  key={idx}
                  className={
                    idx === activeIndex
                      ? classes.imgcardtstmniallrg
                      : classes.imgcardtstmnial
                  }
                >
                  <p className={idx === activeIndex ? classes.ptextnm2 : classes.ptextnm}>
                    {item.text}
                  </p>
                  <div className={classes.imgcontover}>
        <img src={item.image} className={classes.imgcont} alt={item.name} />
                    <div>
                      <p className={idx === activeIndex ? classes.jhndoetxt2 : classes.jhndoetxt}>
                        {item.name}
                      </p>
                      <p className={idx === activeIndex ? classes.pstntxt2 : classes.pstntxt}>
                        {item.position}
                      </p>
                    </div>

                  </div>
                </div>
              ))}
            </div>

            {/* <div className={classes.arrowss}>
            <img src={leftarrow} className={classes.arrows} />
            <img src={rightarrow} className={classes.arrows} />
          </div> */}

            <div className={classes.arrowss}>
              <img
                src={leftarrow}
                className={classes.arrows}
                alt="prev"
                style={{ cursor: "pointer" }}
                onClick={handlePrev}
              />
              <img
                src={rightarrow}
                className={classes.arrows}
                alt="next"
                style={{ cursor: "pointer" }}
                onClick={handleNext}
              />
            </div>

          </div>
        </section>
        <Getstarted />

      </div>
      <Footer />
    </>
  );
}

export default Landingpage;
